import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Typography, TextField, Divider, Paper, Autocomplete, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FormatCurrencyLKR, formatCurrencyForInput, parseCurrencyFromInput } from "../../utils/common/CurrencyFormatter";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { SETTING_API_19 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { BILLING_LABELS } from "../../utils/sys/GrnLabels";
import { GRN_CONSTRAINTS, GRN_REGEX, TAX_CODE, GRN_VIEW_DETAIL } from "../../utils/sys/GrnConstants";
import { GRN_ERROR_MESSAGES, getChargeAlreadyAddedMessage } from "../../utils/sys/GrnValidation";
import { CURRENCY_CONFIG } from "../../utils/sys/GrnConfig";
import { GrnData, AnyForNow, GrnBillingInfoProps } from "../../features/grn/types";

const GrnBillingInfo: React.FC<GrnBillingInfoProps> = ({
  disableBillLevelTax,
  setTaxValues,
  grnData,
  setBillLevelDiscountPercent,
  applyBillLevelDiscountToProducts,
  setBillLevelTaxAmount,
  applyBillLevelTaxToProducts,
  payTax = [],
  selectedSuprefcode,
  grncharges,
  setGrnCharges,
  addedCharges,
  setAddedCharges,
  otherchargevalue,
  setOtherCharges,
  processResponse,
  handleProcessGrn,
  enableTaxPercentInput = true,
  origin,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [editableTaxes, setEditableTaxes] = useState<Record<string, string>>({});
  const [errorText, setErrorText] = useState<string>(""); // for validation messages
const [taxPercentInitialized, setTaxPercentInitialized] = useState<boolean>(false);
const location = useLocation();

  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};
  const initialBillLevelPercent =
    grnData?.billings?.billLevelTaxPercent?.toString() ||
    GRN_CONSTRAINTS.MIN_PERCENTAGE.toString();
const [taxPercent, setTaxPercent] = useState<string>(initialBillLevelPercent);
const taxFieldAlignment = enableTaxPercentInput ? "left" : "right";
   const [selectedChargeIdx, setSelectedChargeIdx] = useState<string | number>("");
   const removedChargeCodesRef = useRef<Set<AnyForNow>>(new Set());
    console.log("tt",processResponse);

    const calSummary = processResponse?.[0]?.dtCalSummary?.[0] || {};
    console.log("calSummary in billing:", calSummary);

  // Helper function to format percentage - removes trailing zeros
  const formatPercentage = (value: number | string): string => {
    const numValue = Number(value);
    if (isNaN(numValue)) return "0";
    
    // Convert to string with 2 decimal places, then remove trailing zeros
    const formatted = numValue.toFixed(2);
    // Remove trailing zeros and decimal point if not needed
    return formatted.replace(/\.?0+$/, '');
  };

  useEffect(() => {
    const initialTaxes = {};
    grnData?.taxes?.forEach((tax) => {
      initialTaxes[tax.taxcode] = (tax.amount ?? 0).toString();
    });
    setEditableTaxes(initialTaxes);
  }, [grnData]);



useEffect(() => {
  console.log("Selected Supplier Ref Code:", selectedSuprefcode);
}, [selectedSuprefcode]);

useEffect(() => {
  if (enableTaxPercentInput) {
    return;
  }

  const fallback =
    grnData?.billings?.billLevelTaxPercent?.toString() ||
    GRN_CONSTRAINTS.MIN_PERCENTAGE.toString();
  setTaxPercent(fallback);
}, [enableTaxPercentInput, grnData?.billings?.billLevelTaxPercent]);


useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTING_API_19, "get", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        // suprefcode: selectedSuprefcode || 0,
        STS: CON_STATUS_ACTIVE,
      });

      console.log("result", result);
      setGrnCharges(result);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  fetchData();
}, [COMPCODE, STAFFMAPLOCODE, ]);


console.log("charges../..:", otherchargevalue);

// Calculate the sum of all charge rates from addedCharges
const addedChargesTotal = Array.isArray(addedCharges)
  ? (addedCharges as any[]).reduce(
      (sum: number, charge: any) => sum + (Number(charge.chaegerate) || 0),
      0
    )
  : 0;

// Calculate the sum of all charge values from otherchargevalue
const otherchargevalueTotal = Array.isArray(otherchargevalue)
  ? (otherchargevalue as any[]).reduce(
      (sum: number, charge: any) => sum + (Number(charge.chargevalue) || 0),
      0
    )
  : 0;

// Total other charges
const totalOtherCharges = addedChargesTotal + otherchargevalueTotal;

// Calculate the total (finalInvoiceValue + otherCharges)
const finalInvoiceValue = Number(grnData.billings?.finalInvoiceValue) || 0;
const netPlusOtherCharges = finalInvoiceValue + totalOtherCharges;
  const vatAmount = Number(grnData.billings?.vatAmount) || 0;
  const isDisabled = vatAmount > 0;
useEffect(() => {
  console.log("Charges updated:", grncharges);
}, [grncharges]);

useEffect(() => {
  if (!enableTaxPercentInput || taxPercentInitialized) {
    return;
  }

  const initial =
    payTax?.[0]?.taxcode === TAX_CODE.BILL_LEVEL
      ? Number(payTax[0].ptaxrate).toString()
      : grnData?.billings?.billLevelTaxPercent
      ? Number(grnData.billings.billLevelTaxPercent).toString()
      : GRN_CONSTRAINTS.MIN_PERCENTAGE.toString();

  setTaxPercent(initial);
  setTaxPercentInitialized(true);
}, [enableTaxPercentInput, payTax, grnData, taxPercentInitialized]);


console.log("bill:", grnData.taxes);
console.log("billing:", grnData.billings);

// Track if we've initialized charges from otherchargevalue to prevent overwriting manually added charges
const chargesFromDbInitializedRef = useRef<boolean>(false);

useEffect(() => {
  // In EditGrn mode, let EditGrn handle initialization - don't initialize here
  // This prevents conflicts and ensures charges are only initialized once
  if (origin === GRN_VIEW_DETAIL.ORIGIN_EDIT) {
    return;
  }

  // Only initialize once when otherchargevalue is first loaded from database
  // This prevents overwriting charges that were manually added by the user
  if (chargesFromDbInitializedRef.current) {
    return; // Already initialized, don't overwrite
  }

  if (Array.isArray(otherchargevalue) && otherchargevalue.length > 0) {
    // 1️⃣ Group by chargecode and sum chargevalue
    const groupedTotals = (otherchargevalue as any[]).reduce((acc: Record<string, number>, curr: any) => {
      const code = String(curr.chargecode);
      const value = Number(curr.chargevalue) || 0;
      acc[code] = (acc[code] || 0) + value;
      return acc;
    }, {} as Record<string, number>);

    // 2️⃣ Now update addedCharges using the grouped totals (merge with existing)
    setAddedCharges((prev) => {
      const updated = Array.isArray(prev) ? [...prev] : [];

      Object.entries(groupedTotals).forEach(([chargecode, totalValue]) => {
        const totalVal = Number(totalValue);
        // Skip if this charge has been removed
        if (removedChargeCodesRef.current.has(chargecode)) {
          return;
        }

        const exists = updated.some(
          (ac: any) => String(ac.chargecode) === String(chargecode)
        );

        if (!exists) {
          // Find the matching charge details from grncharges (for display name)
          const matched = Array.isArray(grncharges)
            ? (grncharges as any[]).find(
                (g) => String(g.chargecode) === String(chargecode)
              )
            : null;

          updated.push({
            ...(matched || { chargecode }),
            chaegerate: totalVal,
            chargevalue: totalVal,
          } as any);
        } else {
          // If exists, update the total values (only on initial load)
          updated.forEach((ac: any) => {
            if (String(ac.chargecode) === String(chargecode)) {
              ac.chargevalue = totalVal;
              ac.chaegerate = totalVal;
            }
          });
        }
      });

      return updated;
    });
    chargesFromDbInitializedRef.current = true; // Mark as initialized
  } else if (Array.isArray(otherchargevalue) && otherchargevalue.length === 0 && Array.isArray(grncharges) && grncharges.length > 0) {
    // If otherchargevalue is empty but grncharges is loaded, mark as initialized
    // This prevents the effect from running again when grncharges loads later
    chargesFromDbInitializedRef.current = true;
  }
}, [otherchargevalue, grncharges, setAddedCharges]);


  return (

<Paper
  sx={{
    backgroundColor: theme.palette.background.paper,
    p: 2,
  }}
>
      <Grid container spacing={1}>
        <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>{BILLING_LABELS.GROSS_AMOUNT}</Typography>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
          <TextField
            fullWidth
            disabled
            defaultValue={CURRENCY_CONFIG.DEFAULT_VALUE}
            value= {FormatCurrencyLKR(
              // Use calSummary if it exists and has been calculated, otherwise fallback to grnData.billings
              (calSummary.totgross !== undefined && calSummary.totgross !== null)
                ? Number(calSummary.totgross)
                : (Number(grnData.billings?.totalGross) || 0)
            )}
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
            size="small"
          />
        </Grid>
        </Grid>
     <Typography variant={"subtitle_m" as any} sx={{  mt: 2, color: theme.palette.text.primary }}>
  {BILLING_LABELS.DISCOUNT}
</Typography>
<Divider sx={{ mb: 2, bgcolor: theme.palette.divider }} />
  
<Grid container spacing={1}>
  {/* Product Discount (LKR) - Show as value when product-level discount exists */}
  {Number(grnData.billings?.productdiscountAmount) > 0 ? (
    <>
      <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
        <Typography sx={styles.grn_bill_name}>
          {BILLING_LABELS.PRODUCT_DISCOUNT_LKR}
        </Typography>
      </Grid>
      <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
        <TextField
          fullWidth
          disabled
          value={FormatCurrencyLKR(
            Number(calSummary.totdiscount) || Number(grnData.billings?.productdiscountAmount) || 0
          )}
          InputProps={{
            sx: { textAlign: "right" },
            inputProps: {
              style: { textAlign: "right" },
            },
          }}
          size="small"
        />
      </Grid>
    </>
  ) : null}
  {/* Additional Discount (%) - Show when no product-level discount (allows entering bill-level discount) */}
  {!(Number(grnData.billings?.productdiscountAmount) > 0) && (
    <>
      <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
        <Typography sx={styles.grn_bill_name}>
          {BILLING_LABELS.ADDITIONAL_DISCOUNT_PERCENT}
        </Typography>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <TextField
          fullWidth
          value={grnData.billings?.billLevelDiscountPercent?.toString() || GRN_CONSTRAINTS.MIN_PERCENTAGE}
          onChange={(e) => {
            let input = e.target.value;

            if (input === "") {
              setBillLevelDiscountPercent(GRN_CONSTRAINTS.MIN_PERCENTAGE);
              return;
            }

            const regex = GRN_REGEX.PERCENTAGE;
            if (regex.test(input)) {
              let value = Number(input);
              value = Math.min(
                GRN_CONSTRAINTS.MAX_PERCENTAGE,
                Math.max(GRN_CONSTRAINTS.MIN_PERCENTAGE, value)
              );
              setBillLevelDiscountPercent(value);
            }
          }}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace", "Tab", "ArrowLeft", "ArrowRight",
              "Delete", ".", "Home", "End"
            ];
            const isNumberKey = /^\d$/.test(e.key);

            if (!isNumberKey && !allowedKeys.includes(e.key)) e.preventDefault();
            if (e.key === "." && (e.target as HTMLInputElement).value.includes(".")) e.preventDefault();
          }}
          onBlur={() => {
            // Apply discount to products when user finishes entering the value
            if (applyBillLevelDiscountToProducts) {
              const value = Number(grnData.billings?.billLevelDiscountPercent) || 0;
              applyBillLevelDiscountToProducts(value);
            }
          }}
          InputProps={{
            sx: { textAlign: "left" },
            inputProps: {
              style: { textAlign: "left" },
              min: GRN_CONSTRAINTS.MIN_PERCENTAGE,
              max: GRN_CONSTRAINTS.MAX_PERCENTAGE,
              step: 0.01,
            },
          }}
          size="small"
        />
      </Grid>
    </>
  )}
</Grid>


    <Typography variant={"subtitle_m" as any} sx={{ ...styles.remo_title_text, mt: 3, color: theme.palette.text.primary }}>
 {BILLING_LABELS.TAX}
</Typography>
<Divider sx={{ mb: 2, bgcolor: theme.palette.divider }} />
  <Grid container spacing={1}>
        <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>{BILLING_LABELS.TAXABLE_VALUE}</Typography>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
          <TextField
            fullWidth
            disabled
            value=   {FormatCurrencyLKR(
              // Use calSummary if available and has been calculated, otherwise fallback to grnData.billings.taxableValue
              (calSummary.totgross !== undefined && calSummary.totgross !== null)
                ? (Number(calSummary.totgross || 0) - (Number(calSummary.totdiscount || 0)))
                : (Number(grnData.billings?.taxableValue) || 0)
            )}
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
            size="small"
            required={!disableBillLevelTax}
          />
        </Grid>
        {/* <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>VAT</Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <TextField
            fullWidth
            defaultValue="0%"
            size="small"
            value={(Number(grnData.billings?.vatAmount) || 0).toFixed(2)}
            disabled
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
          />
        </Grid> */}


  {/* Product Tax (LKR) - Show as value when product-level tax exists */}
  {grnData?.products?.some((item) => Number(item.taxrate) > 0) ? (
    <>
      <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
        <Typography sx={styles.grn_bill_name}>
          {BILLING_LABELS.PRODUCT_TAX_LKR}
        </Typography>
      </Grid>

      <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
        <TextField
          fullWidth
          disabled
          value={FormatCurrencyLKR(
            Number(calSummary.tottax) || Number(grnData.billings?.vatAmount) || 0
          )}
          size="small"
          InputProps={{
            sx: { textAlign: "right" },
            inputProps: {
              style: { textAlign: "right" },
            },
          }}
        />
      </Grid>
    </>
  ) : (
    <>
      {/* Tax (%) - Show when no product-level tax (allows entering bill-level tax) */}
      <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
        <Typography sx={styles.grn_bill_name}>{BILLING_LABELS.TAX_PERCENT}</Typography>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <TextField
          fullWidth
          type="number"
          size="small"
          value={taxPercent}
          onChange={(e) => {
            let input = e.target.value;

            if (input === "") {
              setTaxPercent("");
              setBillLevelTaxAmount(GRN_CONSTRAINTS.MIN_PERCENTAGE);
              return;
            }

            if (input.startsWith("0") && !input.startsWith("0.")) {
              input = input.replace(/^0+/, "");
              if (input === "") input = "0";
            }

            const regex = GRN_REGEX.PERCENTAGE;

            if (regex.test(input)) {
              setTaxPercent(input);
              const value = Math.min(
                GRN_CONSTRAINTS.MAX_PERCENTAGE,
                Math.max(GRN_CONSTRAINTS.MIN_PERCENTAGE, Number(input))
              );
              setBillLevelTaxAmount(value);
            }
          }}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
              ".",
              "Home",
              "End",
            ];
            const isNumberKey = /^[0-9]$/.test(e.key);

            if (!isNumberKey && !allowedKeys.includes(e.key)) e.preventDefault();
            if (e.key === "." && (e.target as HTMLInputElement).value.includes(".")) {
              e.preventDefault();
            }
          }}
          onBlur={() => {
            // Apply tax to products when user finishes entering the value
            if (applyBillLevelTaxToProducts) {
              const value = Number(taxPercent) || 0;
              applyBillLevelTaxToProducts(value);
            }
          }}
          InputProps={{
            sx: { textAlign: "left" },
            inputProps: {
              style: { textAlign: "left" },
              min: GRN_CONSTRAINTS.MIN_PERCENTAGE,
              max: GRN_CONSTRAINTS.MAX_PERCENTAGE,
              step: 0.01,
            },
          }}
        />
      </Grid>
    </>
  )}



</Grid>

  <Grid container spacing={1} pt={2}>
        <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography  sx={styles.grn_bill_name}>{BILLING_LABELS.NET_VALUE}</Typography>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
          <TextField
            fullWidth
            disabled
            // defaultValue="0.00"
            value= {FormatCurrencyLKR(
              // Calculate net value: totnett - charges (or use API calculated values)
              calSummary.totnett !== undefined && calSummary.totnett !== null
                ? calSummary.totnett - (calSummary.totcharges || 0)
                : (grnData?.billings?.netValue !== undefined && grnData?.billings?.netValue !== null
                  ? grnData.billings.netValue
                  : (calSummary.totgross - calSummary.totdiscount) + calSummary.tottax)
            )}
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
            size="small"
          />
        </Grid>
        
        </Grid>
<Typography variant={"subtitle_m" as any} sx={{ ...styles.remo_title_text, mt: 3, color: theme.palette.text.primary }}>
{BILLING_LABELS.CHARGES}
</Typography>
<Divider sx={{ mb: 2, bgcolor: theme.palette.divider }} />
     {/* Dropdown for selecting a charge */}
{/* ➕ Select and Add Charge */}
<Autocomplete
  size="small"
  disablePortal
  options={grncharges}
  getOptionLabel={(option) => option.chargetype || ""}
  value={
    selectedChargeIdx !== "" && grncharges[selectedChargeIdx]
      ? grncharges[selectedChargeIdx]
      : null
  }
  onChange={(event, newValue) => {
    const idx = grncharges.indexOf(newValue);
    setSelectedChargeIdx(idx !== -1 ? idx : "");
    setErrorText("");
  }}
  ListboxProps={{
    style: {
      maxHeight: GRN_CONSTRAINTS.DROPDOWN_MAX_HEIGHT,
      backgroundColor: theme.palette.background.default,
    },
  }}
  renderInput={(params) => (
    <TextField {...params} label={BILLING_LABELS.SELECT_CHARGE} variant="outlined" />
  )}
/>

{/* Display selected charge details */}
{selectedChargeIdx !== "" && grncharges[selectedChargeIdx] && (
  <>
    <Grid container spacing={1} mt={2}>
      <Grid size={{ xs: 9 }}>
        <TextField
          size="small"
          type="text"
          label={BILLING_LABELS.RATE}
          value={formatCurrencyForInput(grncharges[selectedChargeIdx].chaegerate || '')}
          error={Boolean(errorText)}
          helperText={errorText}
          FormHelperTextProps={{
            sx: { fontSize: "12px", color: "red" },
          }}
          onFocus={() => {
            const updated = [...grncharges];
            updated[selectedChargeIdx].chaegerate = "";
            setGrnCharges(updated);
            setErrorText("");
          }}
          onChange={(e) => {
            const input = e.target.value;
            const parsedValue = parseCurrencyFromInput(input);
            const updated = [...grncharges];
            if (parsedValue === "") {
              updated[selectedChargeIdx].chaegerate = "";
              setGrnCharges(updated);
              setErrorText(GRN_ERROR_MESSAGES.RATE_REQUIRED);
              return;
            }
            const regex = GRN_REGEX.AMOUNT;
            if (regex.test(parsedValue)) {
              updated[selectedChargeIdx].chaegerate = parsedValue;
              setGrnCharges(updated);
              setErrorText("");
            } else {
              setErrorText(GRN_ERROR_MESSAGES.INVALID_NUMBER);
            }
          }}
          onBlur={(e) => {
            // Ensure value is properly formatted on blur
            const parsedValue = parseCurrencyFromInput(e.target.value);
            if (parsedValue !== '' && !isNaN(parseFloat(parsedValue))) {
              const updated = [...grncharges];
              updated[selectedChargeIdx].chaegerate = parsedValue;
              setGrnCharges(updated);
            }
          }}
        />
      </Grid>

      <Grid size={{ xs: 3 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton
         type="button"
           sx={{
        padding: "10px 12px",
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        "&:hover": {
          background: theme.palette.primary.dark,
        },
      }}
          onClick={() => {
            const charge = grncharges[selectedChargeIdx];

            if (!charge || !charge.chaegerate) {
              setErrorText(GRN_ERROR_MESSAGES.RATE_REQUIRED_BEFORE_ADD);
              return;
            }

            const alreadyExists = addedCharges.some(
              (c) => String(c.chargecode) === String(charge.chargecode)
            );

            if (alreadyExists) {
              setErrorText(getChargeAlreadyAddedMessage(charge.chargetype || ""));
              return;
            }

            //  Add new charge
            setAddedCharges([...addedCharges, { ...charge }]);

            //  Remove from removed list if it was there
            removedChargeCodesRef.current.delete(charge.chargecode);

            //  Reset the rate in grncharges
            const updatedCharges = [...grncharges];
            updatedCharges[selectedChargeIdx].chaegerate = "";
            setGrnCharges(updatedCharges);

            //  Clear selection & error
            setSelectedChargeIdx("");
            setErrorText("");
          }}
        >
          <AddIcon fontSize="small" />
   
          
        </IconButton>
      </Grid>
    </Grid>

    <Divider sx={{ my: 2 }} />
  </>
)}

{/* 🧾 Added Charges List */}
<Typography variant="subtitle2" sx={{ mb: 1, color: theme.palette.text.primary }}>
  {BILLING_LABELS.ADDED_CHARGES}
</Typography>

{addedCharges.length > 0 &&
  addedCharges
    .filter((charge) => String(charge.chargecode) !== "0")
    .map((charge, idx) => {
      const matchedCharge = Array.isArray(grncharges)
        ? grncharges.find(
            (g) => String(g.chargecode) === String(charge.chargecode)
          )
        : null;

      const displayName = matchedCharge?.chargetype || charge.chargetype;
      const displayValue = charge.chaegerate || charge.chargevalue;

      return (
        <Grid
          container
          spacing={1}
          key={charge.chargecode || idx}
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Grid size={{ xs: 6 }}>
            <Typography sx={styles.grn_bill_name}>{displayName}</Typography>
          </Grid>

          <Grid size={{ xs: 4 }}>
            <Typography sx={{ color: theme.palette.text.primary }}>{FormatCurrencyLKR(displayValue)}</Typography>
          </Grid>

          <Grid size={{ xs: 2 }}>
            <IconButton
              type="button"
              sx={{
                padding: "4px 8px",
                background: theme.palette.error.main,
                color: theme.palette.common.white,
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                "&:hover": {
                  background: theme.palette.error.dark,
                },
              }}
              onClick={() => {
                const removedCharge = addedCharges[idx];

                // 1️⃣ Remove from addedCharges
                const updatedAdded = addedCharges.filter((_, i) => i !== idx);
                setAddedCharges(updatedAdded);

                // 2️⃣ Mark as removed to prevent re-adding
                removedChargeCodesRef.current.add(removedCharge.chargecode);

                // 3️⃣ Clear error and selection
                setSelectedChargeIdx("");
                setErrorText("");
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
      );
    })}

    

        {/* <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>Handling Charges</Typography>
        </Grid>

        <Grid size={{ xs: 6 }}>
          <TextField
            fullWidth
            defaultValue="0"
            value={handlingCharges}
            onChange={(e) => setHandlingCharges(e.target.value)}
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
            size="small"
          />
        </Grid> */}
        {/* <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>Other Charge 1</Typography>
        </Grid>

        <Grid size={{ xs: 6 }}>
          <TextField
            fullWidth
            defaultValue="0"
            value={otherCharges}
            onChange={(e) => setOtherCharges(e.target.value)}
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } }, 
            }}
            size="small"
          />
        </Grid> */}
        {/* <Grid size={{ xs: 6 }} sx={styles.grn_bill_content}>
          <Typography sx={styles.grn_bill_name}>Penalty Charges</Typography>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
          <TextField
            fullWidth
            value={penaltyCharges}
            onChange={(e) => setPenaltyCharges(e.target.value)}
            defaultValue="0.00"
            InputProps={{
              sx: { textAlign: "right" },
              inputProps: { style: { textAlign: "right" } },
            }}
            size="small"
          />
        </Grid> */}

        {/* <Grid size={{ xs: 12 }}>
          <Divider />
        </Grid> */}
         <Grid container spacing={1} pt={2}>
        <Grid size={{ xs: 6 }}>
          <Typography variant={"subtitle_m" as any} fontWeight="bold" sx={{ color: theme.palette.text.primary }}>
            {BILLING_LABELS.TOTAL_LKR}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }} mb={10}>
          <Typography variant={"subtitle_m" as any} fontWeight="bold" sx={{ color: theme.palette.text.primary }}>
          {FormatCurrencyLKR(
            // Prioritize API response totnett (source of truth) over grnData.billings.finalInvoiceValue
            calSummary.totnett !== undefined && calSummary.totnett !== null
              ? calSummary.totnett
              : (grnData?.billings?.finalInvoiceValue !== undefined && grnData?.billings?.finalInvoiceValue !== null
                ? grnData.billings.finalInvoiceValue
                : 0)
          )}
          </Typography>
        </Grid>
    </Grid>

   
    </Paper>

  );
};

export default GrnBillingInfo;
